import { useMemo } from "react";
import MandatoryBreakWarning from ".";
import { useVisible } from "../../../../utils/hooks/useVisible";

export const useManadatoryBreakWarning = () => {
    const { visible, close, selected, open } = useVisible();

    const modal = useMemo(() => {
        return (
            <MandatoryBreakWarning
                isOpen={visible}
                selected={selected}
                close={close}
            />
        );
    }, [close, selected, visible]);

    return { open, modal };
}
